module.exports = __webpack_public_path__ + "media/images/pc/stores/funabashi/access/chiba-funabashi-point2-3@2x-c7ffb591aabc23b671d12c8f64d534e2.webp";